import { render, staticRenderFns } from "./update-inquiry.vue?vue&type=template&id=a412b146"
import script from "./update-inquiry.vue?vue&type=script&lang=js"
export * from "./update-inquiry.vue?vue&type=script&lang=js"
import style0 from "./update-inquiry.vue?vue&type=style&index=0&id=a412b146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports